import React from 'react';
import {
  Box, Container, Typography, Chip
} from '@mui/material';
import { blueGrey } from '@mui/material/colors';
import { motion } from 'framer-motion';
import NoticeTable from '../../components/notice/NoticeTable';

function NoticeListPage() {
  return (
    <Box sx={{ minHeight: 'calc(100vh - 64px)', backgroundColor: '#f4f6f8' }}>
      {/* 헤더 히어로 */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #0d1b2a 0%, #1a3a5c 50%, #0d2137 100%)',
          py: { xs: 10, md: 14 },
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* 배경 그리드 패턴 */}
        <Box sx={{
          position: 'absolute',
          inset: 0,
          backgroundImage: 'linear-gradient(rgba(33,150,243,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(33,150,243,0.05) 1px, transparent 1px)',
          backgroundSize: '50px 50px',
          pointerEvents: 'none',
        }} />
        {/* 글로우 */}
        <Box sx={{
          position: 'absolute',
          inset: 0,
          backgroundImage: 'radial-gradient(ellipse 60% 50% at 50% 50%, rgba(33,150,243,0.12) 0%, transparent 70%)',
          pointerEvents: 'none',
        }} />

        <Container maxWidth="lg">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: [0.25, 0.46, 0.45, 0.94] }}
          >
            <Box sx={{ textAlign: 'center' }}>
              <Chip
                label="고객지원"
                size="small"
                sx={{
                  fontFamily: 'NotoSansKR',
                  fontWeight: 700,
                  fontSize: '11px',
                  letterSpacing: '1px',
                  backgroundColor: 'rgba(33,150,243,0.15)',
                  color: '#90caf9',
                  border: '1px solid rgba(33,150,243,0.3)',
                  mb: 3,
                }}
              />
              <Typography
                sx={{
                  fontFamily: 'NotoSansKR',
                  fontWeight: 900,
                  fontSize: { xs: '32px', md: '52px' },
                  color: '#ffffff',
                  letterSpacing: { xs: '-0.5px', md: '-1.5px' },
                  mb: 2,
                  lineHeight: 1.15,
                }}
              >
                공지사항
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'NotoSansKR',
                  fontWeight: 300,
                  fontSize: { xs: '15px', md: '17px' },
                  color: 'rgba(255,255,255,0.55)',
                  lineHeight: 1.8,
                }}
              >
                다끌레어의 새로운 소식과 공지를 확인하세요
              </Typography>
            </Box>
          </motion.div>
        </Container>
      </Box>

      {/* 공지 테이블 */}
      <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 } }}>
        <Box
          sx={{
            backgroundColor: '#ffffff',
            borderRadius: '20px',
            border: '1px solid #e8ecf0',
            overflow: 'hidden',
            boxShadow: '0 4px 24px rgba(0,0,0,0.05)',
          }}
        >
          <NoticeTable />
        </Box>
      </Container>
    </Box>
  );
}

export default NoticeListPage;
